import React from 'react';
import { GlyphDot } from '@visx/glyph';
import type { RenderTooltipGlyphProps } from '@visx/xychart/lib/components/Tooltip';
import { GlyphProps } from '@visx/xychart';
import { NullableChartDataPoint } from '../types';

export const renderGlyph = ({
  x,
  y,
  size,
  color,
  onPointerMove,
  onPointerOut,
  onPointerUp,
}: GlyphProps<NullableChartDataPoint['values']>) => {
  const handlers = { onPointerMove, onPointerOut, onPointerUp };
  return (
    <GlyphDot
      left={x}
      top={y}
      r={size}
      fill="white"
      stroke={color}
      strokeWidth={2}
      {...handlers}
    />
  );
};

export const renderTooltipGlyph = ({
  isNearestDatum,
  ...rest
}: RenderTooltipGlyphProps<NullableChartDataPoint['values']>) => {
  if (!isNearestDatum) {
    return null;
  }

  return renderGlyph(rest);
};

export const renderTooltipGlyphMultiple = (
  props: RenderTooltipGlyphProps<NullableChartDataPoint['values']>
) => renderGlyph(props);

export type RenderTooltipGlyph = typeof renderTooltipGlyph;
